<div class="password-wrapper" [style.background-image]="'url(' + image + ')'">

  <div class="content-bg">

  </div>

  <div class="content">
    <div class="title">パスワードを入力してください。</div>
    
    <form [formGroup]="form">
      <div class="form-wrapper">
        <div class="form">
          <div class="row">
            <div class="form-field password">
              <mat-form-field appearance="outline">
                <mat-label>パスワード</mat-label>
                <input matInput formControlName="formPassword" type="text" autocomplete="off">
                <!-- <mat-hint>1000文字以内</mat-hint> -->
                <mat-error *ngIf="formPassword.invalid && formPassword.errors.required">パスワードは必須です</mat-error>
                <mat-error *ngIf="formPassword.invalid && formPassword.errors.maxlength">パスワードは100文字以内です</mat-error>
                <mat-error *ngIf="formPassword.invalid && formPassword.errors.serverError">パスワードが正しくありません</mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <div class="btn-wrapper">
        <div class="btn"><button [class.disabled]="form.invalid" (click)="done()">確認</button></div>
      </div>
    </form>

  </div>

</div>